import { store } from '@/store/index'

const MaskMoneyOnly = {}
MaskMoneyOnly.install = Vue => {
  Vue.directive('MaskMoneyOnly', {
    update: (el, binding) => {
      const s = parseInt(binding.value)
      const cts = store.getters.selectedStore.currency_thousands_sep
      const cdp = store.getters.selectedStore.currency_dec_point
      const val = (s / 1).toFixed().replace(cts, cdp)
      el.innerHTML = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, cts)
    },
    bind: function(el, binding, vnode) {
      const s = parseInt(binding.value)
      const cts = store.getters.selectedStore.currency_thousands_sep
      const cdp = store.getters.selectedStore.currency_dec_point
      const val = (s / 1).toFixed().replace(cts, cdp)
      el.innerHTML = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, cts)
    }
  })
}

export default MaskMoneyOnly
